import * as Yup from "yup";

export const broadcastMessageVariableSchema = (fieldNames: string[]) => {
  // Dynamically create a Yup schema where all fields are required
  const schemaFields = fieldNames.reduce((acc, fieldName) => {
    acc[fieldName] = Yup.string().required(
      `${fieldName.replaceAll("_", " ")} is required`
    );
    return acc;
  }, {} as Record<string, Yup.StringSchema>);

  return Yup.object().shape(schemaFields);
};
